import { RoleName } from "@/core/constants";

export const licenseRoutes = [
  {
    path: "/licenses",
    name: "licenseList",
    meta: {
      title: "Licenses",
      tag: "licenses.licenses",
      localise: true,
      },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/LicenseList.vue"),
  },
  {
    path: "/licenses/new/:userId",
    name: "licenseNew",
    meta: {
      title: "Grant a license",
      tag: "licenses.grantALicense",
      localise: true,
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/LicenseForm.vue"),
  },
  {
    path: "/licenses/:licenseId",
    name: "licenseView",
    meta: {
      title: "License View",
    },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/LicenseForm.vue"),
  },
  {
    path: "/licenses/:licenseId/expire",
    name: "licenseExpire",
    meta: {
      title: "Expire License",
      roles: `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator},` +
        `${RoleName.RegionalTrainingManager}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/LicenseExpireForm.vue"),
  },
  {
    path: "/licenses/:licenseId/revoke",
    name: "licenseRevoke",
    meta: {
      title: "Revoke License",
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/LicenseRevokeForm.vue"),
  },
  {
    path: "/licenses/:licenseId/amend",
    name: "licenseAmend",
    meta: {
      title: "Amend License",
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/LicenseAmend.vue"),
  },
  {
    path: "/licenses/:licenseId/audit/create",
    name: "createQualityAudit",
    meta: {
      title: "Create Quality Audit",
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator}` +
        `${RoleName.UnionTrainingManager}`  +
        `${RoleName.UnionAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/QualityAuditForm.vue"),
  },
  {
    path: "/licenses/:licenseId/audit/edit/:qualityAuditId",
    name: "editQualityAudit",
    meta: {
      title: "Edit Quality Audit",
      tag: "qualityAudit.editQualityAudit",
      localise: true,
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator},` +
        `${RoleName.UnionTrainingManager},`  +
        `${RoleName.UnionAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/QualityAuditForm.vue"),
  },
  {
    path: "/audits/submit/:qualityAuditId",
    name: "submitQualityAudit",
    meta: {
      title: "Edit Quality Audit",
      tag: "qualityAudit.editQualityAudit",
      localise: true,
    },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/QualityAuditSubmitForm.vue"),
  },
  {
    path: "/audits/manage",
    name: "listAuditsToManage",
    meta: {
      title: "Audit list (Manager)",
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.IrisAdministrator},` +
        `${RoleName.UnionTrainingManager},`  +
        `${RoleName.UnionAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/ManagerAuditList.vue"),
  },
  {
    path: "/audits/audit",
    name: "listAuditsToAuditor",
    meta: {
      title: "Audit list (Auditor)",
      localise: true,
    },
    component: () =>
      import(/* webpackChunkName: "license" */ "@/views/license/AuditorAuditList.vue"),
  },
];
